export default __webpack_public_path__ + "static/media/Scarf.fbb31feb.png";